import { createActions, createState, createReducer } from 'reduxsauce-crud'

const d = { deep: true }

export const TeacherDistributionRedux = createActions({
  TeacherDistributionExcelRequest: [''],
  TeacherDistributionExcelSuccess: [''],
  TeacherDistributionExcelError: ['error'],
},
{
  prefix: 'TEACHER_DISTRIBUTION_',
  defaultActions: {
    get: true,
  },
},
)

const { Types, Creators } = TeacherDistributionRedux
export const TeacherDistributionTypes = Types
export default Creators

export const INITIAL_STATE = createState({
  sending: {
    fetching: false,
    error: null,
  },
}, {
  get: true,
})

const TeacherDistributionExcelRequest = state => state.merge({ sending: { fetching: true, error: null } }, d)

const TeacherDistributionExcelSuccess = state => state.merge({
  sending: {
    fetching: false,
    error: null,
  },
}, d)
const TeacherDistributionExcelError = (state, { error }) =>
  state.merge({ sending: { fetching: false, error } }, d)

export const reducer = createReducer(INITIAL_STATE, {
  [Types.TeacherDistributionExcelRequest]: TeacherDistributionExcelRequest,
  [Types.TeacherDistributionExcelSuccess]: TeacherDistributionExcelSuccess,
  [Types.TeacherDistributionExcelError]: TeacherDistributionExcelError,
},
{
  defaultActions: {
    get: true,
  },
  Types,
},
)



// WEBPACK FOOTER //
// ./src/Data/Redux/TeacherDistributionRedux.js